var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyingGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GTM o"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: 0.65,
    y: 0.65,
    width: 6.16667,
    height: 8.7,
    stroke: "#D425A3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 0.65,
    y: 11.65,
    width: 6.16667,
    height: 3.7,
    stroke: "#D425A3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 15.35,
    y: 15.35,
    width: 6.16667,
    height: 8.7,
    transform: "rotate(180 15.35 15.35)",
    stroke: "#D425A3",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 15.35,
    y: 4.35,
    width: 6.16667,
    height: 3.7,
    transform: "rotate(180 15.35 4.35)",
    stroke: "#D425A3",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyingGroup);
export default __webpack_public_path__ + "static/media/buyingGroup.0da497ddea052ca56999d0fea31607e5.svg";
export { ForwardRef as ReactComponent };